import TopoBackground from '@/components/TopoBackground'

/**
 * Dashboard'un zemini — halka açık sitenin zemininin ta kendisi.
 *
 * Üç site tek bir mülk gibi okunsun diye panel de `turksletloose.com` ile aynı
 * yüzeyde durur: `#0b0b0d` grafit üstünde prosedürel eşyükselti haritası
 * (simplex alan + marching squares, ölçüm ızgarası, artı nişanları, kesikli
 * kesit çizgisi). Eski zemin `dashboardbg.webp` fotoğrafı + film greni +
 * `bg-black/75` perdesiydi: fotoğrafı görünmez edecek kadar karartılmış bir
 * fotoğraftı, yani ne görüntü ne dokuydu — yalnızca indirilen bir dosya.
 *
 * **Tek zemin, dallanma yok.** Strateji bölümü eskiden ayrı bir katman
 * (`StrategicBackdrop`) kullanıyordu çünkü fotoğraf haritayla yarışıyordu;
 * zemin zaten kontur haritası olunca o gerekçe düştü ve panelde rotaya göre
 * değişen bir arka plan kalmadı.
 *
 * Vinyet kenarları düşürür: kartlar merkezde aydınlatılmış bir masa üstünde
 * durur, sidebar ve başlık çubuğu kenarın karanlığına yaslanır.
 */
export default function DashboardBackdrop() {
  return (
    <div className="absolute inset-0 overflow-hidden bg-[#0b0b0d]">
      <TopoBackground />

      {/* Vinyet — merkez aydınlık, kenarlar düşer */}
      <div
        className="pointer-events-none absolute inset-0"
        style={{
          background:
            'radial-gradient(120% 100% at 50% 35%, transparent 0%, transparent 45%, oklch(0 0 0 / 55%) 100%)',
        }}
      />
    </div>
  )
}
